<template>
  <div>
    <div class="navbar-header">
      <div class="column-content">
        <img src="../assets/icon_rounded_256.png" alt="logo" width="40px" height="40px" />
        <span class="navbar-brand primary" href="javascript:;">
          易退税
        </span>
      </div>
      <p class="center">退税就是这么简单</p>
    </div>

    <div class="weui-grids margin-top-thirdly">
      <!--<a href="javascript:;" class="weui-grid">-->
        <!--<div class="weui-grid__icon">-->
          <!--<img src="../assets/logo.png" alt="">-->
        <!--</div>-->
        <!--<p class="weui-grid__label">退税流程</p>-->
      <!--</a>-->
      <!--<a href="javascript:;" class="weui-grid">-->
        <!--<div class="weui-grid__icon">-->
          <!--<img src="../assets/logo.png" alt="">-->
        <!--</div>-->
        <!--<p class="weui-grid__label">在线客服</p>-->
      <!--</a>-->
      <!--<a href="javascript:;" class="weui-grid">-->
        <!--<div class="weui-grid__icon">-->
          <!--<img src="../assets/logo.png" alt="">-->
        <!--</div>-->
        <!--<p class="weui-grid__label">关于</p>-->
      <!--</a>-->
      <!---->
      <!--<a href="javascript:;" class="weui-grid">-->
        <!--<div class="weui-grid__icon">-->
          <!--<img src="../assets/logo.png" alt="">-->
        <!--</div>-->
        <!--<p class="weui-grid__label">退税政策</p>-->
      <!--</a>-->
      <!--<a href="javascript:;" class="weui-grid">-->
        <!--<div class="weui-grid__icon">-->
          <!--<img src="../assets/logo.png" alt="">-->
        <!--</div>-->
        <!--<p class="weui-grid__label">网站首页</p>-->
      <!--</a>-->
      <!--<a href="javascript:;" class="weui-grid">-->
        <!--<div class="weui-grid__icon">-->
          <!--<img src="../assets/logo.png" alt="">-->
        <!--</div>-->
        <!--<p class="weui-grid__label">关于</p>-->
      <!--</a>-->
    </div>
    <div class="how-to">
      <div class="company">
        Safety Tax Free
      </div>
      <div class="title-h2 head">
        完成退税，只需三步
      </div>
      <div class="step">
        <div class="icon">
          <img class="img-shop">
        </div>
        <div class="title-h1">
          01. 购物时领取税单
        </div>
        <div class="content">
          <p>在商店购物付款时请领取易退税退税单。复查确保您的个人资料完整齐全。</p>
          <p>姓名，国家以及护照号码是必填信息。</p>
          <p>使用易退税APP扫描退税单上的二维码进行<strong>绑定</strong>以及<strong>上传小票照片</strong>。</p>
        </div>
      </div>
      <div class="step">
        <div class="icon">
          <img class="img-stamp">
        </div>
        <div class="title-h1">
          02. 海关盖章
        </div>
        <div class="content">
          <p>在最后离开欧洲前，请至机场海关完成退税单盖章。</p>
          <p>如果退税单上无海关盖章将无法完成退税。</p>
        </div>
      </div>
      <div class="step">
        <div class="icon">
          <img class="img-delivery">
        </div>
        <div class="title-h1">
          03. 回国后预约顺丰收单
        </div>
        <div class="content">
          <p>回国后请使用顺丰速运<strong>隔日达到付</strong>服务将<strong>税单及小票</strong>邮寄至北京收单中心。</p>
          <p>请复查确保所有购物单据粘在或者钉在了易退税的退税单背后。有效完整的购物单据是进行退税的必要条件。</p>
          <p>我们将在收到后3-5天进行处理，处理完之后余额将显示在您的易退税APP上，并可以进行提现操作。</p>
        </div>
      </div>
    </div>

    <tab-bar></tab-bar>
    <download-app></download-app>
  </div>
</template>
<style lang="stylus">
  .navbar-header span
    font-size 22px
    line-height 50px
  .navbar-header
    text-align center
    margin 8px auto
  .column-content
    display inline-block
    img
      vertical-align middle
    span
      display inline-block
      vertical-align middle
  .how-to
    font-family "Roboto", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif
    color #ffffff
    background-color #373e40
    padding 20px 20px 100px 20px
    .company
      font-size 30px
      text-align center
      text-transform: uppercase
      text-shadow 2px 0 #ffffff
      letter-spacing 3px
      font-weight bold
      margin-bottom 10px
    .head
      text-align center
      margin-bottom 20px
    .icon
      width 150px
      height 150px
      background-color #00b0f0
      border-radius 50%
      top 0
      bottom 0
      left 0
      right 0
      margin 50px auto 40px auto
      .img-shop
        background-image url(../assets/store.png)
      .img-stamp
        background-image url(../assets/stamp.png)
      .img-delivery
        background-image url(../assets/delivery.png)
      img
        display inline-block
        width 100%
        height 100%
        background-repeat no-repeat
        background-position center
        border-radius 50%
        background-size 80% 80%
    .title-h1
      font-size 20px
      margin-bottom 20px
    .title-h2
      font-size 16px
    .content
      color #82abba
      font-size 14px
      p
        margin-bottom 16px
</style>
<script>
  import TabBar from '../components/TabBar'
  import DownloadApp from '../components/DownloadApp'

  export default{
    components: {
      TabBar,
      DownloadApp
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?4e47abae